import { useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useEndFlowModal } from '@/contexts/endFlowModalContext';

import {
  authenticateEpisode,
  getAllChaptersOfShow,
  getAllShows,
  getInfluencerDiscount,
  getUserPurchasedShows,
  purchaseShow
} from '../functions/show';

export const useGetAllShows = () =>
  useQuery({
    queryKey: ['get-all-shows'],
    queryFn: getAllShows
  });

export const useGetUserPurchasedShows = () =>
  useQuery({
    queryKey: ['get-user-purchased-shows'],
    queryFn: getUserPurchasedShows
  });

export const useGetAllEpisodesOfShow = ({ showId }: { showId: string }) =>
  useQuery({
    queryKey: ['get-all-episodes-of-show'],
    queryFn: () => getAllChaptersOfShow({ showId }),
    enabled: !!showId
  });

export const useAuthenticateEpisode = () =>
  useMutation({
    mutationKey: ['authenticate-episode'],
    mutationFn: authenticateEpisode
  });

export const usePurchaseShow = () => {
  const { showError } = useEndFlowModal();
  return useMutation({
    mutationKey: ['purchase-show'],
    mutationFn: purchaseShow,
    onError: (e: AxiosError) => {
      showError({});
      console.error('Error purchasing show', e.response?.data);
    }
  });
};

export const useGetInfluencerDiscount = ({ influencerCode }: { influencerCode: string }) =>
  useQuery({
    queryKey: ['get-influencer-discount'],
    queryFn: () => getInfluencerDiscount({ influencerCode }),
    enabled: !!influencerCode
  });

export const useGetInfluencerDiscountAsync = () =>
  useMutation({
    mutationKey: ['get-influencer-discount-async'],
    mutationFn: getInfluencerDiscount
  });
